import useSWR from 'swr';
import axios from 'axios';

function usePotentialHires({ shouldFetch = true, page, perPage, sortField, sortOrder, search, category }) {
  return useSWR(shouldFetch ? [
    `${process.env.REACT_APP_API_URL}/potential-hires`, page, perPage, sortField, sortOrder, search, category
  ] : null, async ([url, page, perPage, sortField, sortOrder, search, category]) => {
    const params = new URLSearchParams();

    if (page) params.append('page', page);
    if (perPage) params.append('perPage', perPage);
    if (sortField) params.append('sortField', sortField);
    if (sortOrder) params.append('sortOrder', sortOrder);
    if (search) params.append('search', search);
    if (category) params.append('category', category);

    const { data: { hires, count } } = await axios.get(`${url}?${params.toString()}`);

    return { hires, count };
  });
}

export default usePotentialHires;
